// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".juniper[data-v-4c9ce7f2]{background:rgba(51,203,154,.2);color:#33cb9a}.cherry[data-v-4c9ce7f2]{background:rgba(218,85,101,.2);color:#da5565}.amber[data-v-4c9ce7f2]{background-color:rgba(244,144,12,.2);color:#f4900c}.honey[data-v-4c9ce7f2]{background:rgba(243,203,81,.2);color:#f3cb51}.neutral[data-v-4c9ce7f2]{background-color:hsla(220,2%,76%,.2);color:#c0c1c3}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
